import React, { useEffect, useState, useMemo } from "react";
import { Button, Form, InputGroup, Modal, Row } from "react-bootstrap";
import { BlobProvider, PDFViewer } from '@react-pdf/renderer';
import moment from "moment";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { authorizedRequests } from "../../../axios/axios-config";
import { toastify } from "../../../helperFunctions/toastify";
import {
	resetValue,
	setData,
	setForm,
} from "../../../redux/slices/StaffFormsSlices";
import _ from "lodash";
import SelectComponent from "../../SharedComponents/SelectComponent";
import InvoicePDF from "../../SharedComponents/InvoicePDF";
import ExternalPDF from "../../SharedComponents/ExternalPDF";
import { getFormatedTime, getInvoiceId } from "../../../helperFunctions/utils";
import PackagesTable from "./PackagesTable";
import DateInput from "../../SharedComponents/DateInput";
import { getPaymentMethodList } from "../../../apis/paymentMethod";
import { getSetting, getExternalTemplate } from "../../../apis/generalSetting";

export default function AddEditBilling() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const { billingForm, selectedSession } = useSelector(
		(state) => state.staffForm,
	);
	const isNewBilling = location.state.newBilling;

	const [companySetting, setCompanySetting] = useState(null);
	const [setting, setSettings] = useState({});
	const [promo, setPromo] = useState(0);
	const [tax, setTax] = useState([]);
	const [usePoint, setUsePoint] = useState(0);
	const [subTotal, setSubTotal] = useState(0);
	const [total, setTotal] = useState(subTotal);
	const [newQty, setNewQty] = useState(0);
	const [newDisc, setNewDisc] = useState(0);
	const [newDiscType, setNewDiscType] = useState("Amount");
	const [itemToEdit, setItemToEdit] = useState();
	const [itemToEditPrice, setItemToEditPrice] = useState(0);
	const [itemToDel, setItemToDel] = useState();
	const [openModal, setOpenModal] = useState(false);
	const [isFree, setIsFree] = useState(false);
	const [rewardPoints, setRewardPoints] = useState(0);
	const [status, setStatus] = useState(null);
	const [expiryDate, setExpiryDate] = useState(null);
	const [gst, setGst] = useState(0);
	const [programExpiration, setProgramExpiration] = useState([])
	const [paymentMethod, setPaymentMethod] = useState(null);
	const [paymentMethodName, setPaymentMethodName] = useState("")
	const [optionalAmount, setOptionalAmount] = useState(false);
	const [invoicePayment, setInvoicePayment] = useState(null);
	const [fileInvoice, setFileInvoice] = useState(null);
	const [externalTemplates, setExternalTemplates] = useState([]);
	const [modalExternal, setModalExternal] = useState();

	const [sessionInvoices, setSessionInvoices] = useState([]);
	const [membershipCategories, setMembershiCategories] = useState([]);
	const [pointsExpiry, setPointsExpiry] = useState();
	const [selectedMedicationCategory, setSelectedMedicationCategory] =
		useState(null);

	const [installmentAmount, setInstallmentAmount] = useState("");
	const [paymentRecord, setPaymentRecoed] = useState(null);
	const [allPaymentRecorde, setAllPaymentRecords] = useState([])
	const [paymentInInstallment, setPaymentInInstallment] = useState(false);
	const [appointmentExist, setAppointmentExist] = useState(true)
	const [recalculateSub, setRecalculateSub] = useState(false);
	const [needInvoice, setNeedInvoice] = useState(false);
	const numberFormatter = Intl.NumberFormat('en-US');

	// const [extraProducts, setExtraProducts] = useState([]);
	// const [extraPackages, setExtraPackages] = useState([]);
	// const [extraServices, setExtraServices] = useState([]);

	const [showModal, setShowModal] = useState({
		medication: false,
		treatment: false,
		package: false,
		points: false,
		edit: false,
		other: false,
	});
	const [tempSelectedSession, setTempSession] = useState({});
	const [invoicesArray, setInvoicesArray] = useState([]);
	const [isMember, setIsMember] = useState(false);
	const [selectedPatient, setSelectedPatient] = useState("");
	const [selectedOption, setSelectedOption] = useState("");
	const [modalSelectedOption, setModalSelectedOption] = useState("");
	const [extraStates, setExtraStates] = useState({
		product_id: null,
		others_description: "",
		others_price: 0,
		product_quantity: null,
		product_unit_price: null,
		product_discount: 0,
		product_price: null,
		package_id: null,
		package_expiry: null,
		treatment_used: [],
		product_used: [],
		previous_package_unique_id: null,
		previous_package_id: null,
		// previous_package_billing_id: null,
		previous_treatment_used: [],
		previous_product_used: [],
		previous_billing_id: null,
		// package_points: 0,
		service_id: null,
		service_quantity: null,
		service_unit_price: null,
		service_discount: 0,
		service_price: null,
	});
	const [sessions, setSessions] = useState([]);
	const [patientSession, setPatientSession] = useState();

	const [options, setOptions] = useState({
		patients: [],
		locations: [],
		branches: [],
		medications: [],
		packages: [],
		previousPackages: [],
		categoryCost: [],
		allPatients: [],
		campaigns: [],
		tax: [],
		paymentMethods: [],
		programs: [],
		status: [
			{
				label: "Paid",
				value: true,
			},
			{
				label: "Unpaid",
				value: false,
			},
		],
		discountType: [
			{ value: 'Percentage', label: 'Percentage' },
			{ value: 'Amount', label: 'Amount' },
		]
	});

	useEffect(() => {
		getSetting()
			.then((res) => {
				if (res.status !== "Fail") {
					setCompanySetting(res);
				}
			})
	}, []);

	useEffect(() => {
		getExternalTemplate()
			.then((res) => {
				if (res.status !== "Fail") {
					setExternalTemplates(res);
				}
			})
	}, []);

	const setModal = (name) => {
		setShowModal({
			medication: name === "medication" ? !showModal?.medication : false,
			treatment: name === "treatment" ? !showModal?.treatment : false,
			package: name === "package" ? !showModal?.package : false,
			points: name === "points" ? !showModal?.points : false,
			edit: name === "edit" ? !showModal?.edit : false,
			other: name === "other" ? !showModal?.other : false,
		});
	};

	const onFormChange = (name, value) => {
		dispatch(setForm({ parent: "billingForm", child: name, value }));
	};

	const submitForm = async (haveInvoice) => {
		if (sessionInvoices?.length == 0) {
			toastify("Please add at least 1 item", "error");
			return;
		}
		// if (typeof status !== "boolean" && !paymentInInstallment) {
		// 	toastify("Status is missing", "error");
		// 	return;
		//     }
		if (+installmentAmount === 0 && optionalAmount === true) {
			return toastify(
				"Amount you entered cannot be zero",
				"error"
			)
		}
		if (+installmentAmount > total) {
			return toastify(
				"Amount you entered is greater than remaining amount",
				"error"
			)
		}
		if (isNewBilling && !appointmentExist) {
			return toastify(
				"Please create appointment first",
				"error"
			)
		}
		const purchasingProduct = sessionInvoices.filter((o) => o.type == "PRODUCT")
		const availProducts = options.medications.find((m) => m.id === purchasingProduct[0]?.id)
		if (+(purchasingProduct[0]?.qty) > availProducts?.qty) {
			toastify(`${purchasingProduct[0]?.name} stock is not enough`, "error")
		}

		const extraService = sessionInvoices
			.filter((o) => o.type == "SERVICE")
			.map((o) => {
				return {
					service_id: o.id,
					service_qty: parseInt(o.qty),
					service_discount: o.discount,
					service_discountType: o.discountType,
					service_price: o.total_price,
					service_unit_price: o.price,
				};
			});

		const extraProduct = sessionInvoices
			.filter((o) => o.type == "PRODUCT")
			.map((o) => {
				return {
					product_id: o.id,
					product_qty: parseInt(o.qty),
					product_discount: o.discount,
					product_discountType: o.discountType,
					product_price: o.total_price,
					product_unit_price: o.price,
				};
			});

		const extraPackage = sessionInvoices
			.filter((o) => o.type == "PACKAGE")
			.map((o) => {
				return {
					package_id: o.isAlreadyPaid ? o.id.split(",")[0] : o.id,
					isAlreadyPaid: o.isAlreadyPaid ?? false,
					billingId: o.billingId,
					package_expiry: o.expiredDate,
					// points: parseInt(o.points) || 0,
					package_qty: parseInt(o.qty) || 1,
					package_discount: o.discount || 0,
					package_price: o.total_price,
					package_unit_price: o.price,
					treatments_used:
						o?.treatments?.length > 0
							? [
								...o.treatments?.map((p) => ({
									id: p.id,
									used: p.used,
								})),
							]
							: [],
					products_used:
						o?.products?.length > 0
							? [
								...o.products?.map((p) => ({
									id: p.id,
									used: p.used,
								})),
							]
							: [],
				};
			});
		const others = sessionInvoices
			?.filter((o) => o.type == "OTHER")
			?.map((o) => {
				return {
					description: o.description,
					total_price: o?.total_price,
				};
			});
		const data = {
			session: selectedSession?.all_data?._id,
			patient: billingForm?.patient,
			branch: billingForm.branch,
			pointsExpiry: expiryDate,
			paymentMethod: paymentMethod,
			gst: gst,
			location: billingForm.location,
			recommend: billingForm.recommended ? billingForm.recommended : null,
			campaign: billingForm.campaign,
			others,
			categoryCosts: options.categoryCost
				?.filter((o) => o.isChecked)
				?.map((o) => o.id),
			tax: tax,
			treatment: [...extraService],
			product: [...extraProduct],
			package: [...extraPackage],
			usePoints: usePoint || 0,
			actualAmount: subTotal,
			totalAmount: total,
			remarks: billingForm.remarks,
			campaignRemarks: billingForm.campaignRemarks,
			isFree,
			rewardPoints: status ? parseInt(rewardPoints) : null,
			isPaymentCompleted: !optionalAmount ? true : status,
			promo,
			isPaymentInInstallment: optionalAmount,
			installmentAmount: +installmentAmount,
			paymentMethodName,
			programExpiration
		};
		if (location?.state?.formStatus != "Edit" && !paymentInInstallment) {
			const { result, error } = await authorizedRequests({
				url: "payment/createPayment",
				method: "post",
				data: data,
			});
			if (error) {
				setInvoicePayment(null);
				toastify(error.message, "error");
				return;
			}
			toastify("Billing created succesfully", "success");
			getPaymentAfterSubmit(result, haveInvoice);
			// setInvoicePayment(true);
		} else if (paymentInInstallment) {
			const payload = {
				totalAmount: paymentRecord.totalAmount,
				payed: paymentRecord.payed + (+installmentAmount),
				remaining: (paymentRecord.remaining - (+installmentAmount)).toFixed(2),
				paymentMethod: paymentMethodName,
				currentPaidAmount: +installmentAmount,
				programExpiration
			};
			const { result, error } = await authorizedRequests({
				url: "payment/updatePayment",
				method: "post",
				data: {
					installmentRecord: payload,
					sessionId: location.state.session._id,
				},
			});
			if (result) {
				getPaymentAfterSubmit(result, haveInvoice);
				toastify("Payment successfully updated", "success");
			}
		} else {
			const { result, error } = await authorizedRequests({
				url: "payment/updatePayment",
				method: "post",
				data: { ...data, dataId: location?.state?.dataId },
			});
			if (error) {
				setInvoicePayment(null);
				toastify(error.message, "error");
				return;
			}
			getPaymentAfterSubmit(result, haveInvoice);
			toastify("Billing updated succesfully", "success");
		}
		dispatch(resetValue("billingForm"));
		navigate(-1);
		return;
	};

	const onExtraFormChange = (name, value) => {
		setExtraStates((val) => {
			return { ...val, [name]: value };
		});
	};
	const getCalculatedPrice = (
		id,
		array,
		quantity,
		discount,
		discountType,
		name,
	) => {
		const item_price = array.find((o) => o.id == id).price * quantity;
		if (!discount || discount == 0) {
			onExtraFormChange(name, item_price);
			return;
		} else if (discountType === "Percentage") {
			const disc_price = item_price * (1 - discount / 100);
			onExtraFormChange(name, disc_price);
		} else {
			const disc_price = item_price - discount;
			onExtraFormChange(name, disc_price);
		}
	};

	const returnCalculatedPrice = () => {
		if (newDiscType === "Percentage") {
			const totalPrice = newQty * itemToEditPrice;
			const disc_price = (totalPrice * (1 - newDisc / 100));
			return disc_price;
		} else {
			const disc_price = newQty * itemToEditPrice - newDisc;
			return disc_price;
		}
	}

	const getPreviousPackages = async () => {
		const { result, error } = await authorizedRequests({
			url: "payment/listPreviousPackagesByPatientId",
			method: "post",
			data: {
				patientId: billingForm.patient,
			},
		});
		if (error) {
			toastify(error.message, "error");
			return;
		}

		let tempArr = result.data.map((o) => {
			const all_packages = o.package
				?.filter(
					(k) =>
						new Date(k.package_expiry).getTime() >=
						new Date().getTime()
				)
				?.map((k) => {
					return {
						billingId: o._id,
						packageId: k?.package_id?._id,
						label: k?.package_id?.name,
						value: `${k?.package_id?._id},${o._id}`,
						discount: k?.package_discount || 0,
						id: k?.package_id?._id,
						price: k?.package_price,
						qty: k?.package_qty,
						treatments: k?.treatments?.map((treatment) => {
							const disc_price =
								treatment?.treatment?.price *
								(1 - treatment?.discount / 100);
							return {
								id: treatment?.treatment?._id,
								name: treatment?.treatment?.name,
								qty: treatment.limit,
								unit_price: treatment?.treatment?.price,
								discount: treatment?.discount,
								total_price: disc_price,
								used: treatment.used,
							};
						}),
						products: k?.products?.map((product) => {
							const disc_price =
								product?.product?.unitSellingPrice *
								(1 - product?.discount / 100);

							return {
								id: product?.product?._id,
								name: product?.product?.name,
								qty: product.qty,
								unit_price: product?.product?.unitSellingPrice,
								discount: product?.discount,
								total_price: disc_price,
								used: product.used,
							};
						}),
					};
				});
			return [...all_packages];
		});
		tempArr = _.flattenDeep(tempArr);
		setOptions((val) => {
			return { ...val, previousPackages: tempArr };
		});
	};
	const getBranches = async () => {
		const { result, error } = await authorizedRequests({
			url: "branch/listOfBranch",
			method: "get",
		});
		if (error) {
			toastify(error.message ?? "Failed to get branches", "error");
			return;
		}
		const tempArr = result.data.map((o) => {
			return {
				id: o._id,
				name: o.name,
				label: o.name,
				value: o._id,
				locations: o.location,
			};
		});
		setOptions((val) => {
			return { ...val, branches: tempArr };
		});
	};

	const getPaymentBySessionId = async () => {
		const payload = {
			sessionId: location.state.session._id,
		};
		const result = await authorizedRequests({
			url: "payment/getPaymentbySessionId",
			method: "post",
			data: payload,
		});
		if (result) {
			const { paymentRecord, isPaymentInInstallment } =
				result?.result?.data;
			setPaymentRecoed(paymentRecord[paymentRecord.length - 1]);
			setAllPaymentRecords(paymentRecord)
			setPaymentInInstallment(isPaymentInInstallment);
		}
	};

	const getPaymentMethods = async () => {
		const { result, error } = await getPaymentMethodList();
		if (error) {
			toastify(error.message || "Failed to get payment", "error");
			return;
		}
		setOptions((val) => {
			return { ...val, paymentMethods: result.data };
		});
	};

	const getPatients = async () => {
		const { result, error } = await authorizedRequests({
			url: `session/getSessionByLocation/${billingForm.location}`,
			method: "get",
		});
		if (error) {
			toastify(error.message ?? "Failed to get Patients", "error");
			return;
		}
		var tempPatientsArr = result.data.map((o) => {
			return {
				name: o?.appointment?.patient?.patientProfile?.fullName,
				id: o?.appointment?.patient?._id,
				label: o?.appointment?.patient?.patientProfile?.fullName,
				value: o?.appointment?.patient?._id,
				isMember: o?.appointment?.patient?.isMember,
				kol: o?.appointment?.patient?.patientProfile?.recommendFrom,
			};
		});

		tempPatientsArr = _.uniqWith(tempPatientsArr, _.isEqual);
		// console.log("~~", tempPatientsArr);

		const tempAllPatientsArr = tempPatientsArr.map((x) => ({
			name: x.name,
			id: "",
			label: x.name,
			value: x.id,
			isMember: x.isMember,
			kol: "",
		}));

		const patientsArr = _.uniqWith(
			[...tempPatientsArr, ...tempAllPatientsArr],
			(arrVal, othVal) => {
				return arrVal.value === othVal.value;
			},
		);

		//edit by jonny
		if (billingForm?.patient) {
			setIsMember(patientsArr?.find(
				(o) => o?.value == billingForm.patient,
			)?.isMember);
		}

		setOptions((val) => {
			return { ...val, patients: patientsArr };
		});

		setSessions(result.data);
	};
	const getMedications = async () => {
		const { result, error } = await authorizedRequests({
			url: "product/listOfProducts",
			method: "get",
		});
		if (error) {
			toastify(error.message ?? "Failed to get products", "error");
			return;
		}

		let tempCategories = [];
		const tempArr = result?.data?.map((o) => {
			const CategoryIndex = tempCategories.findIndex(
				(c) => c._id == o?.type?._id,
			);
			if (CategoryIndex == -1) {
				tempCategories.push({ ...o?.type });
			}
			return {
				id: o?._id,
				name: o?.name,
				value: o?._id,
				label: o?.name,
				price: o?.unitSellingPrice,
				type: o?.type?.name,
				typeId: o?.type?._id,
				qty: o?.qty
			};
		});

		setOptions((val) => {
			return { ...val, medications: tempArr };
		});
		setOptions((val) => {
			return { ...val, medicationCategories: tempCategories };
		});
	};
	const getTreatments = async () => {
		const { result, error } = await authorizedRequests({
			url: "treatment/listOfTreatment",
			method: "get",
		});
		if (error) {
			toastify(error.message ?? "Failed to get products", "error");
			return;
		}
		const tempArr = result?.data?.map((o) => {
			return {
				id: o?._id,
				name: o?.name,
				value: o?._id,
				label: o?.name,
				price: o?.price,
			};
		});

		setOptions((val) => {
			return { ...val, treatments: tempArr };
		});
	};
	const getPackages = async () => {
		const { result, error } = await authorizedRequests({
			url: "package/listOfPackages",
			method: "get",
		});
		if (error) {
			toastify(error.message ?? "Failed to get packages", "error");
			return;
		}
		const tempArr = result?.data?.map((o) => {
			const name = `${o?.name} ${o?.promoCode
				? "-" +
				o?.promoCode?.name +
				"(" +
				new Date(
					o.promoCode?.vaildStartDate,
				).toLocaleDateString() +
				" - " +
				new Date(o.promoCode?.vaildEndDate).toLocaleDateString() +
				")"
				: ""
				}`;
			return {
				id: o?._id,
				name,
				value: o?._id,
				label: name,
				price: o.packagePrice,
				qty: 1,
				discount: 0,
				expiredDate: o?.expiredDate,
				treatments: o?.treatments?.map((treatment) => {
					const disc_price =
						treatment?.treatment?.price *
						(1 - treatment?.discount / 100);
					return {
						id: treatment?.treatment?._id,
						name: treatment?.treatment?.name,
						qty: treatment.limit,
						unit_price: treatment?.treatment?.price,
						discount: treatment?.discount,
						total_price: disc_price,
						// used: treatment.limit,
						used: 0,
					};
				}),
				products: o?.products?.map((product) => {
					const disc_price =
						product?.product?.unitSellingPrice *
						(1 - product?.discount / 100);

					return {
						id: product?.product?._id,
						name: product?.product?.name,
						qty: product.qty,
						unit_price: product?.product?.unitSellingPrice,
						discount: product?.discount,
						total_price: disc_price,
						// used: product.qty,
						used: 0,
					};
				}),
			};
		});
		setOptions((val) => {
			return { ...val, packages: tempArr };
		});
	};
	const getCategoryCost = async () => {
		const { result, error } = await authorizedRequests({
			url: "categoryCost/listOfcategoryCost",
			method: "get",
		});
		if (error) {
			toastify(error.message ?? "Failed to get category cost", "error");
			return;
		}
		const tempArr = result?.data?.map((o) => {
			return {
				id: o._id,
				name: o.name,
				isChecked:
					location?.state?.categoryCosts?.length > 0
						? location?.state?.categoryCosts?.indexOf(o._id) !== -1
						: false,
			};
		});
		setOptions((val) => {
			return { ...val, categoryCost: tempArr };
		});
	};
	const getAllPatients = async () => {
		const { result, error } = await authorizedRequests({
			url: "patient/listOfPatient",
			method: "get",
		});
		if (error) {
			toastify(error.message ?? "Failed to get patients", "error");
			return;
		}
		const tempArr = result?.data?.map((o) => {
			return {
				id: o._id,
				name: o?.patientProfile?.fullName,
				value: o._id,
				label: o?.patientProfile?.fullName,
				points: o?.points || 0,
				pointsExpiry: new Date(o?.pointsExpiry),
				dob: new Date(o?.patientProfile?.dob),
				isMember: o?.isMember,
			};
		});
		setOptions((val) => {
			return { ...val, allPatients: tempArr };
		});
	};
	const getCampaigns = async () => {
		const { result, error } = await authorizedRequests({
			url: "compaign/listOfCompaign",
			method: "get",
		});
		if (error) {
			toastify(error.message ?? "Failed to get campaigns", "error");
			return;
		}
		const tempArr = result?.data?.map((o) => {
			return {
				id: o._id,
				name: o.name,
				value: o._id,
				label: o.name,
			};
		});
		setOptions((val) => {
			return { ...val, campaigns: tempArr };
		});
	};
	const getTax = async () => {
		const { result, error } = await authorizedRequests({
			url: "taxSetting/listOfTaxSetting",
			method: "get",
		});
		if (error) {
			toastify(error.message, "error");
			return;
		}
		const tempArr = result?.data?.map((o) => {
			return {
				id: o._id,
				name: o.name,
				type: o.typeValue,
				value: o._id,
				taxValue: o.value,
				label: o.name,
			};
		});

		setOptions((val) => {
			return { ...val, tax: tempArr };
		});

		if (tax.length == 0) {
			const getGST = tempArr.find(
				(o) => o?.name?.toLowerCase() == "gst",
			)?.id;
			if (getGST) {
				setTax([getGST]);
			}
		}
	};
	const getMembershipSetting = async () => {
		const { result, error } = await authorizedRequests({
			url: "membershipSetting/listOfMembershipSetting",
			method: "get",
		});
		if (error) {
			toastify(
				error.message ?? "Failed to get membership settings",
				"error",
			);
			return;
		}
		setSettings({
			value: result.data[0].point,
			memberExpiry: result.data[0].expForMember,
			nonMemberExpiry: result.data[0].expForNonMember,
			isDouble: result.data[0]?.isDouble,
			rewardPoint: result?.data[0]?.rewardPoint,
		});
	};
	const getMembershipCategories = async () => {
		const { result, error } = await authorizedRequests({
			url: "membershipCategory/listOfMembershipCategory",
			method: "get",
		});
		if (error) {
			toastify("Failed to get membership categories", "error");
			return;
		}
		setMembershiCategories(result?.data);
	};
	const getTotalSum = (arr) => {
		let sum = 0;
		arr?.filter((o) => !o.isAlreadyPaid)?.forEach((o) => {
			if (!isNaN(Number(o.total_price))) sum += Number(o.total_price);
		});
		return sum;
	};

	const makeSessionForNewBilling = async () => {
		const { result, error } = await authorizedRequests({
			url: "session/getPatientTodaySession",
			method: "post",
			data: { patientID: selectedPatient },
		});
		if (error) {
			setAppointmentExist(false)
			toastify(error.message, "error");
			return;
		}
		dispatch(
			setData({
				parent: "selectedSession",
				value: {
					all_data: result?.data,
				},
			}),
		);
		// toastify("Session created succesfully", "success");
	}
	const getProgramExpiration = async () => {
		const { result, error } = await authorizedRequests({
			url: "program/listPrograms",
			method: "get",
		});
		if (error) {
			toastify(error.message, "error");
			return;
		}
		const tempArr = result?.data?.map((o) => {
			return {
				id: o._id,
				name: o.name,
				description: o.description,
				startDate: o.startDate,
				expiryDate: o.expiryDate,
				label: o.name,
				value: o._id,
			};
		});
		setOptions((val) => {
			return { ...val, programs: tempArr };
		});
	}

	useEffect(() => {
		getBranches();
		getMedications();
		getPackages();
		getTreatments();
		getCategoryCost();
		getAllPatients();
		getCampaigns();
		getMembershipSetting();
		getMembershipCategories();
		getTax();
		getPaymentMethods();
		getProgramExpiration();
	}, []);

	useEffect(() => {
		getPaymentBySessionId();
	}, [location]);

	useEffect(() => {
		if (isNewBilling && selectedPatient && selectedPatient !== "") {
			makeSessionForNewBilling()
		}
	}, [selectedPatient])

	useMemo(() => {
		if (isFree) {
			setTotal(0);
		} else {
			if (subTotal > 0) {
				// debugger;
				let amount = parseInt(subTotal);
				selectedOption?.value === "Percentage" ? amount = amount * (1 - (promo ?? 0) / 100) : amount = amount - promo ?? 0;
				// amount = amount * (1 - (promo ?? 0) / 100);
				let percentTax = 0;
				let exactTax = 0;
				tax.forEach((singleTax) => {
					const t = options.tax.find((o) => o.id == singleTax);
					if (t && t.type == "Percentage") {
						percentTax += t.taxValue;
						// amount = amount + (amount * t.taxValue) / 100;
					} else if (t && t.type !== "Percentage") {
						exactTax += t.taxValue;
						// amount = amount + t.taxValue;
					}
				});

				amount = amount - (usePoint * setting?.value || 0);
				setTotal(parseFloat(amount).toFixed(2));

				amount = amount + (amount * percentTax) / 100;
				amount = amount + exactTax;
				setGst(parseFloat(amount).toFixed(2));
			}
		}
	}, [subTotal, tax, promo, usePoint, setting?.value, options?.tax, isFree, selectedOption]);

	useMemo(() => {
		if (billingForm.branch && options.branches?.length > 0) {
			const loc = options.branches.find(
				(o) => o.id == billingForm.branch,
			);
			setOptions((val) => {
				return {
					...val,
					locations: loc?.locations.map((o) => {
						return {
							id: o._id,
							name: o.name,
							label: o.name,
							value: o._id,
						};
					}),
				};
			});
		}
	}, [billingForm.branch, options.branches]);
	useMemo(() => {
		if (billingForm.location) {
			getPatients();
		}
	}, [billingForm.location]);
	useMemo(() => {
		if (billingForm.patient) getPreviousPackages();
	}, [billingForm.patient]);
	useMemo(() => {
		if (
			billingForm.patient &&
			options.patients.length > 0 &&
			membershipCategories.length > 0
		) {
			const curPoints = options?.allPatients?.find(
				(o) => o.id == billingForm.patient,
			);
			const patMembershitp = membershipCategories.find(
				(o) => o.startFrom <= curPoints?.points,
			);
			if (patMembershitp?._id) {
				setPointsExpiry(setting.memberExpiry);
			} else {
				setPointsExpiry(setting.nonMemberExpiry);
			}
		}
	}, [options.patients, billingForm.patient, membershipCategories, setting]);
	useMemo(() => {
		const today = new Date();
		const selectedPatient = options.allPatients.find(x => x.id === billingForm.patient)

		if (selectedPatient && selectedPatient.isMember) {
			if (total && setting.rewardPoint) {
				let tempPoint = Math.ceil(subTotal / setting.rewardPoint);
				if (setting.isDouble && (today.getMonth() === selectedPatient.dob.getMonth() && today.getDate() === selectedPatient.dob.getDate())) {
					tempPoint = tempPoint * 2;
				}
				setRewardPoints(tempPoint);
			}
		}
	}, [setting.rewardPoint, setting.isDouble, total, billingForm.patient]);
	useMemo(() => {
		if (billingForm.patient && billingForm.isNew) {
			const requiredSessions = sessions.filter(
				(o) => o?.appointment?.patient?._id == billingForm?.patient,
			);

			const tempArr = requiredSessions.map((o) => {
				return {
					id: o._id,
					startTime: o.startTime,
					status: o.status,
					endTime: o.endTime,
					date: o.date
						? new Date(o?.date).toLocaleDateString()
						: "Date not found",
					staff: o.staff?.map((k) => {
						return {
							id: k._id,
							name: k.username,
						};
					}),
					all_data: { ...o },
				};
			});
			setPatientSession(tempArr);
		}
	}, [billingForm.patient, billingForm.isNew]);
	useMemo(() => {
		if (extraStates.product_id && extraStates.product_quantity) {
			getCalculatedPrice(
				extraStates.product_id,
				options.medications,
				extraStates.product_quantity,
				null,
				"",
				"product_price",
			);
		}
	}, [extraStates.product_id, extraStates.product_quantity]);
	useMemo(() => {
		if (extraStates.service_id && extraStates.service_quantity) {
			getCalculatedPrice(
				extraStates.service_id,
				options.treatments,
				extraStates.service_quantity,
				null,
				"",
				"service_price",
			);
		}
	}, [extraStates.service_id, extraStates.service_quantity]);

	useMemo(() => {
		if (!selectedSession) {
			if (location?.state?.formStatus == "Edit") {
				const servicesArr = location?.state?.treatment?.map((o) => {
					return {
						...o,
						type: "SERVICE",
						total_price: o.service_price,
						qty: o.service_qty,
						discount: o.service_discount,
						discountType: o.service_discountType,
						price: o.service_unit_price,
						name: o?.service_id?.name,
						id: o?.service_id?._id,
					};
				});

				const productsArr = location?.state?.product?.map((o) => {
					return {
						...o,
						type: "PRODUCT",
						total_price: o.product_price,
						qty: o.product_qty,
						discount: o.product_discount,
						discountType: o.product_discountType,
						price: o.product_unit_price,
						name: o?.product_id?.name,
						id: o?.product_id?._id,
					};
				});

				const packagesArr = location?.state?.package?.map((o) => {
					return {
						...o,
						type: "PACKAGE",
						points: o?.points,
						expiredDate: o.package_expiry,
						products: o.package_id.products.map((k) => {
							const disc_price =
								k?.product?.unitSellingPrice *
								(1 - k?.discount / 100);
							const used = o?.products_used?.find(
								(productUsed) =>
									productUsed.id == k?.product?._id,
							)?.used;

							return {
								id: k?.product?._id,
								name: k?.product?.name,
								qty: k.qty,
								unit_price: k?.product?.unitSellingPrice,
								discount: k?.discount,
								total_price: disc_price,
								used: used,
							};
						}),
						treatments: o?.package_id?.treatments?.map((k) => {
							const disc_price =
								k?.treatment?.price * (1 - k?.discount / 100);
							const used = o?.treatments_used?.find(
								(productUsed) =>
									productUsed.id == k?.treatment?._id,
							)?.used;
							return {
								id: k?.treatment?._id,
								name: k?.treatment?.name,
								qty: k.limit,
								unit_price: k?.treatment?.price,
								discount: k?.discount,
								total_price: disc_price,
								used: used,
							};
						}),
						total_price: o.package_price,
						qty: o.package_qty,
						discount: o.package_discount,
						price: o.package_unit_price,
						id: o?.package_id?._id,
						name: o?.package_id?.name,
						isAlreadyPaid: o?.isAlreadyPaid,
					};
				});

				const others = location?.state?.others?.map((o) => {
					return { ...o, type: "OTHER" };
				});

				const tempArr = [
					...servicesArr,
					...packagesArr,
					...productsArr,
					...others,
				];
				setSessionInvoices(tempArr);
			}
		}
		if (selectedSession) {
			if (location?.state?.formStatus == "Edit") {
				const servicesArr = location?.state?.treatment?.map((o) => {
					return {
						...o,
						type: "SERVICE",
						total_price: o.service_price,
						qty: o.service_qty,
						discount: o.service_discount,
						discountType: o.service_discountType,
						price: o.service_unit_price,
						name: o?.service_id?.name,
						id: o?.service_id?._id,
					};
				});
				const productsArr = location?.state?.product?.map((o) => {
					return {
						...o,
						type: "PRODUCT",
						total_price: o.product_price,
						qty: o.product_qty,
						discount: o.product_discount,
						discountType: o.product_discountType,
						price: o.product_unit_price,
						name: o?.product_id?.name,
						id: o?.product_id?._id,
					};
				});

				const packagesArr = location?.state?.package?.map((o) => {
					return {
						...o,
						type: "PACKAGE",
						expiredDate: o.package_expiry,
						points: o?.points,
						total_price: o.package_price,
						qty: o.package_qty,
						discount: o.package_discount,
						price: o.package_unit_price,
						id: o?.package_id?._id,
						name: o?.package_id?.name,
						isAlreadyPaid: o?.isAlreadyPaid,
					};
				});

				const tempArr = [
					...servicesArr,
					...packagesArr,
					...productsArr,
				];
				setSessionInvoices(tempArr);
			} else {
				// const productsArr =
				// 	selectedSession?.all_data?.appointment?.products?.map(
				// 		(o) => {
				// 			return {
				// 				qty: 1,
				// 				discount: 0,
				// 				price: o?.unitSellingPrice,
				// 				total_price: o?.unitSellingPrice,
				// 				type: "PRODUCT",
				// 				name: o?.name,
				// 				id: o._id,
				// 			};
				// 		},
				// 	);

				const prescriptionDrugs =
					selectedSession?.all_data?.patientPrescriptionSheet?.map(
						(o) => {
							return {
								qty: o.quantity,
								discount: o.discount,
								price: o.unitPrice,
								total_price: o.unitPrice * o.quantity,
								type: "PRODUCT",
								name: o.drugName,
								id: o.drugId,
								typeDrug: o.type,
							}
						}
					)

				const tempArr = [
					...sessionInvoices.filter((o) => o.isExtra),
					// ...productsArr,
					...prescriptionDrugs || []
				];
				setSessionInvoices(tempArr);
			}
		}
	}, [
		selectedSession,
		location?.state?.session?.formStatus,
		location?.state?.treatment,
		location?.state?.package,
		location?.state?.product,
	]);
	useMemo(() => {
		if (sessionInvoices.length > 0) {
			let t = getTotalSum(sessionInvoices);
			// if (t !== 0 && promo !== 0) {
			// 	t = t - (t * promo / 100);
			// }

			setSubTotal(t.toFixed(2));
		}
	}, [sessionInvoices, recalculateSub]);
	useMemo(() => {
		if (location?.state?.session) {
			dispatch(
				setForm({
					parent: "billingForm",
					child: "isNew",
					value: false,
				}),
			);
			dispatch(
				setForm({
					parent: "billingForm",
					child: "formStatus",
					value: location?.state?.formStatus || "New",
				}),
			);
			dispatch(
				setForm({
					parent: "billingForm",
					child: "dataId",
					value: location?.state?.dataId || undefined,
				}),
			);
			dispatch(
				setForm({
					parent: "billingForm",
					child: "branch",
					value: location?.state?.session?.branch?._id,
				}),
			);
			dispatch(
				setForm({
					parent: "billingForm",
					child: "location",
					value: location?.state?.session?.location,
				}),
			);
			dispatch(
				setForm({
					parent: "billingForm",
					child: "patient",
					value: location?.state?.session?.appointment?.patient?._id,
				}),
			);
			dispatch(
				setData({
					parent: "selectedSession",
					value: {
						all_data: location?.state?.session,
					},
				}),
			);
		}
		if (location?.state?.formStatus == "Edit") {
			dispatch(
				setForm({
					parent: "billingForm",
					child: "branch",
					value: location?.state?.branch,
				}),
			);
			dispatch(
				setForm({
					parent: "billingForm",
					child: "location",
					value: location?.state?.location,
				}),
			);
			dispatch(
				setForm({
					parent: "billingForm",
					child: "patient",
					value: location?.state?.patient?._id,
				}),
			);
			setTax(
				Array.isArray(location?.state?.tax)
					? location?.state?.tax
					: [location?.state?.tax],
			);
			// setTotal(location?.state?.totalAmount);
			setUsePoint(location?.state?.usePoints);
			setRewardPoints(location?.state?.rewardPoints);
			setStatus(location?.state?.status);
			setPaymentMethod(location?.state?.paymentMethod?._id);
			setPaymentMethodName(location?.state.paymentMethod?.name)
			setPromo(location?.state?.promo);
			dispatch(
				setForm({
					parent: "billingForm",
					child: "recommended",
					value: location?.state?.recommend,
				}),
			);
			dispatch(
				setForm({
					parent: "billingForm",
					child: "campaign",
					value: location?.state?.campaign,
				}),
			);
			dispatch(
				setForm({
					parent: "billingForm",
					child: "remarks",
					value: location?.state?.remarks,
				}),
			);
		}
	}, [location?.state?.session]);
	const session_column = [
		{
			name: "",
			selector: (row) => row.input,
			wrap: true,
			width: `${billingForm.isNew ? "150px" : 0}`,
		},
		{
			name: "Date",
			selector: (row) => row.date,
			wrap: true,
		},
		{
			name: "Staff",
			selector: (row) => row.staff,
			wrap: true,
		},
		{
			name: "Session Time In",
			selector: (row) => row.startTime,
			wrap: true,
		},
		{
			name: "Session Time Out",
			selector: (row) => row.endTime,
			wrap: true,
		},
	];
	const payment_column = [
		{
			name: "",
			selector: (row) => row.input,
			wrap: true,
			width: `${billingForm.isNew ? "150px" : 0}`,
		},
		{
			name: "Date",
			selector: (row) => row.date,
			wrap: true,
		},
		{
			name: "Total Amount",
			selector: (row) => row.totalAmount,
			wrap: true,
		},
		{
			name: "Payed",
			selector: (row) => row.currentPaidAmount,
			wrap: true,
		},
		{
			name: "Remaining",
			selector: (row) => row.remaining,
			wrap: true,
		},
	];
	const session_data = billingForm.isNew
		? patientSession
			?.filter((o) => o.status !== "Completed")
			?.map((e, index) => {
				return {
					index: index,
					date: e.date,
					startTime: getFormatedTime(e.startTime),
					endTime: getFormatedTime(e.endTime),
					staff: (
						<>
							{e?.staff?.map((o) => {
								return <div className="">{o.name}</div>;
							})}
						</>
					),
					input: (
						<>
							{billingForm.isNew ? (
								<>
									<input
										type="checkbox"
										checked={
											tempSelectedSession.id == e.id
										}
										onClick={() => {
											setTempSession(e);
										}}
									/>
								</>
							) : (
								<></>
							)}
						</>
					),
				};
			})
		: [
			{
				index: 0,
				date: new Date(
					selectedSession?.all_data?.date,
				).toLocaleDateString(),
				startTime: getFormatedTime(
					selectedSession?.all_data?.startTime,
				),
				endTime: getFormatedTime(
					selectedSession?.all_data?.endTime,
				),
				staff: (
					<>
						{selectedSession?.all_data?.staff?.map((o) => {
							return <div className="">{o.username}</div>;
						})}
					</>
				),
			},
		];
	const others_column = [
		{
			name: "Description",
			selector: (row) => row.description,
		},
		{
			name: "Price",
			selector: (row) => row.price,
		},
		{
			name: "Action",
			selector: (row) => row.action,
			width: "200px"
		},
	];

	const others_data = sessionInvoices
		?.map((e, index) => {
			return {
				index,
				description: e.description,
				price: e.total_price?.toLocaleString(),
				type: e.type,
				isExtra: e.isExtra,
				action: (
					<div className="d-flex ">
						<div
							className="cursor-pointer"
							onClick={() => {
								onExtraFormChange(
									"others_description",
									e.description,
								);
								onExtraFormChange(
									"others_price",
									e.total_price,
								);
								setItemToEdit(index);
								setModal("other");
							}}
						>
							<i className="fa fa-pen"></i>
						</div>
						<div
							className="ms-3  cursor-pointer icon-width"
							onClick={() => {
								setItemToDel(index);
								setOpenModal(true);
							}}
						>
							<i className="fa fa-trash"></i>
						</div>
					</div>
				),
			};
		})
		?.filter((e) => e.type == "OTHER");
	const package_column = [
		{
			name: "Type",
			selector: (row) => row.type,
			wrap: true,
		},
		{
			name: "Name",
			selector: (row) => row.name,
			wrap: true,
		},
		{
			name: "Unit Price",
			selector: (row) => row.price,
			wrap: true,
		},
		{
			name: "Limit",
			selector: (row) => row.limit,
			wrap: true,
		},
		{
			name: "Used",
			selector: (row) => row.used,
			wrap: true,
		},
		{
			name: "Discount",
			selector: (row) => row.discount,
			wrap: true,
		},
		{
			name: "Subtotal",
			selector: (row) => row.total_price,
			wrap: true,
		},
	];

	const products_column = [
		{
			name: "Item Description",
			selector: (row) => row.name,
			wrap: true,
		},
		{
			name: "Type",
			selector: (row) => row.typeDrug === "external" ? "External" : "Internal",
			wrap: true,
		},
		{
			name: "Unit Price",
			selector: (row) => row.price,
			wrap: true,
		},
		{
			name: "Limit",
			selector: (row) => row.qty,
			wrap: true,
		},
		{
			name: "Discount",
			selector: (row) => row.discount,
			wrap: true,
		},
		{
			name: "Amount",
			selector: (row) => row.total_price,
			wrap: true,
		},
		{
			name: "Action",
			selector: (row) => row.action,
			wrap: true,
			width: "200px"
		},
	];
	console.log("====sssss", sessionInvoices)
	const products_data = sessionInvoices
		.map((o, i) => {
			return {
				name: o.name,
				price: o.price,
				type: o.type,
				qty: o.qty,
				discount: o.discount || 0,
				total_price: o.total_price?.toLocaleString(),
				isAlreadyPaid: o.isAlreadyPaid,
				typeDrug: o.typeDrug,
				action: (
					<div className="d-flex ">
						{
							o.typeDrug !== "external" ? (
								<React.Fragment>
									{!o.isAlreadyPaid ? (
										<>
											<div
												className="cursor-pointer"
												onClick={() => {
													setItemToEdit(i);
													setNewQty(o.qty);
													setNewDisc(o.discount);
													setNewDiscType(o.discountType);
													setItemToEditPrice(o.price);
													setModal("edit");
												}}
											>
												<i className="fa fa-pen"></i>
											</div>
										</>
									) : (
										<div className="me-3"> </div>
									)}
									<div
										className="ms-3  cursor-pointer icon-width"
										onClick={() => {
											setItemToDel(i);
											setOpenModal(true);
										}}
									>
										<i className="fa fa-trash"></i>
									</div>
								</React.Fragment>
							) : (
								<div
									className="ms-3 cursor-pointer icon-width"
								>
								</div>
							)
						}
					</div>
				),
			};
		})
		.filter((o) => o.type == "PRODUCT");
	const treatments_data = sessionInvoices
		.map((o, i) => {
			return {
				name: o.name,
				price: o.price,
				type: o.type,
				qty: o.qty,
				discount: o.discount || 0,
				total_price: o.total_price?.toLocaleString(),
				isAlreadyPaid: o.isAlreadyPaid,
				action: (
					<div className="d-flex ">
						{!o.isAlreadyPaid ? (
							<>
								<div
									className="cursor-pointer"
									onClick={() => {
										setItemToEdit(i);
										setNewQty(o.qty);
										setNewDisc(o.discount);
										setNewDiscType(o.discountType);
										setItemToEditPrice(o.price);
										setModal("edit");
									}}
								>
									<i className="fa fa-pen"></i>
								</div>
							</>
						) : (
							<div className="me-3"> </div>
						)}
						<div
							className="ms-3  cursor-pointer icon-width"
							onClick={() => {
								setItemToDel(i);
								setOpenModal(true);
							}}
						>
							<i className="fa fa-trash"></i>
						</div>
					</div>
				),
			};
		})
		.filter((o) => o.type == "SERVICE");
	const newPackage = options?.packages?.find(
		(o) => o.id == extraStates.package_id,
	);
	const previousPackage = options?.previousPackages?.find(
		(o) =>
			o.id == extraStates.previous_package_id &&
			o.billingId == extraStates.previous_billing_id,
	);
	const newPackProducts =
		newPackage?.products?.map((o, i) => {
			return {
				index: i,
				name: o.name,
				type: "Product",
				price: o.unit_price,
				limit: o.qty,
				used: (
					<>
						<div className="d-flex">
							<div
								className="pointer"
								onClick={() => {
									if (o.used == 0) return;
									newPackage.products[i].used = o.used - 1;
									const updatedPackages =
										options.packages?.map((p) => {
											if (p.id == newPackage.id) {
												return newPackage;
											}
											return p;
										});
									setOptions((val) => {
										return {
											...val,
											packages: updatedPackages,
										};
									});
								}}
							>
								<i
									class="fa fa-minus-square"
									style={{ color: "#34556F" }}
									aria-hidden="true"
								></i>
							</div>
							<span className="mx-2">{o.used}</span>
							<div
								className="pointer"
								onClick={() => {
									if (o.used == o.qty) return;
									newPackage.products[i].used = o.used + 1;
									const updatedPackages =
										options.packages?.map((p) => {
											if (p.id == newPackage.id) {
												return newPackage;
											}
											return p;
										});
									setOptions((val) => {
										return {
											...val,
											packages: updatedPackages,
										};
									});
								}}
							>
								<i
									class="fa fa-plus-square"
									style={{ color: "#34556F" }}
									aria-hidden="true"
								></i>
							</div>
						</div>
					</>
				),
				discount: `${o.discount ? o.discount : 0}%`,
				total_price: o.total_price,
			};
		}) ?? [];
	const previousPackProducts =
		previousPackage?.products?.map((o, i) => {
			return {
				index: i,
				name: o.name,
				type: "Product",
				price: o.unit_price?.toLocaleString(),
				limit: o.qty,
				isAlreadyPaid: true,
				used: (
					<>
						<div className="d-flex">
							<div
								className="pointer"
								onClick={() => {
									if (o.used == 0) return;
									previousPackage.products[i].used =
										o.used - 1;
									const updatedPackages =
										options.previousPackages?.map((p) => {
											if (p.id == previousPackage.id) {
												return previousPackage;
											}
											return p;
										});
									setOptions((val) => {
										return {
											...val,
											previousPackages: updatedPackages,
										};
									});
								}}
							>
								<i
									class="fa fa-minus-square"
									style={{ color: "#34556F" }}
									aria-hidden="true"
								></i>
							</div>
							<span className="mx-2">{o.used}</span>
							<div
								className="pointer"
								onClick={() => {
									if (o.used == o.qty) return;
									previousPackage.products[i].used =
										o.used + 1;
									const updatedPackages =
										options.previousPackages?.map((p) => {
											if (p.id == previousPackage.id) {
												return previousPackage;
											}
											return p;
										});
									setOptions((val) => {
										return {
											...val,
											previousPackages: updatedPackages,
										};
									});
								}}
							>
								<i
									class="fa fa-plus-square"
									style={{ color: "#34556F" }}
									aria-hidden="true"
								></i>
							</div>
						</div>
					</>
				),
				discount: `${o.discount ? o.discount : 0}%`,
				total_price: o.total_price,
			};
		}) ?? [];
	const newPackTreatments =
		newPackage?.treatments?.map((o, i) => {
			return {
				index: i,
				name: o.name,
				type: "Treatment",
				price: o.unit_price?.toLocaleString(),
				limit: o.qty,
				used: (
					<>
						<div className="d-flex">
							<div
								className="pointer"
								onClick={() => {
									if (o.used == 0) return;
									newPackage.treatments[i].used = o.used - 1;
									const updatedPackages =
										options.packages?.map((p) => {
											if (p.id == newPackage.id) {
												return newPackage;
											}
											return p;
										});
									setOptions((val) => {
										return {
											...val,
											packages: updatedPackages,
										};
									});
								}}
							>
								<i
									class="fa fa-minus-square"
									style={{ color: "#34556F" }}
									aria-hidden="true"
								></i>
							</div>
							<span className="mx-2">{o.used}</span>
							<div
								className="pointer"
								onClick={() => {
									if (o.used == o.qty) return;
									newPackage.treatments[i].used = o.used + 1;
									const updatedPackages =
										options.packages?.map((p) => {
											if (p.id == newPackage.id) {
												return newPackage;
											}
											return p;
										});
									setOptions((val) => {
										return {
											...val,
											packages: updatedPackages,
										};
									});
								}}
							>
								<i
									class="fa fa-plus-square"
									style={{ color: "#34556F" }}
									aria-hidden="true"
								></i>
							</div>
						</div>
					</>
				),
				discount: `${o.discount ? o.discount : 0}%`,
				total_price: o.total_price,
			};
		}) ?? [];
	const previousPackTreatments =
		previousPackage?.treatments?.map((o, i) => {
			return {
				index: i,
				name: o.name,
				type: "Treatment",
				isAlreadyPaid: true,
				price: o.unit_price,
				limit: o.qty,
				used: (
					<>
						<div className="d-flex">
							<div
								className="pointer"
								onClick={() => {
									if (o.used == 0) return;
									previousPackage.treatments[i].used =
										o.used - 1;
									const updatedPackages =
										options.previousPackages?.map((p) => {
											if (p.id == previousPackage.id) {
												return previousPackage;
											}
											return p;
										});
									setOptions((val) => {
										return {
											...val,
											previousPackages: updatedPackages,
										};
									});
								}}
							>
								<i
									class="fa fa-minus-square"
									style={{ color: "#34556F" }}
									aria-hidden="true"
								></i>
							</div>
							<span className="mx-2">{o.used}</span>
							<div
								className="pointer"
								onClick={() => {
									if (o.used == o.qty) return;
									previousPackage.treatments[i].used =
										o.used + 1;
									const updatedPackages =
										options.previousPackages?.map((p) => {
											if (p.id == previousPackage.id) {
												return previousPackage;
											}
											return p;
										});
									setOptions((val) => {
										return {
											...val,
											previousPackages: updatedPackages,
										};
									});
								}}
							>
								<i
									class="fa fa-plus-square"
									style={{ color: "#34556F" }}
									aria-hidden="true"
								></i>
							</div>
						</div>
					</>
				),
				discount: `${o.discount ? o.discount : 0}%`,
				total_price: o.total_price,
			};
		}) ?? [];
	const package_data = [
		...newPackProducts,
		// ...previousPackProducts,
		...newPackTreatments,
		// ...previousPackTreatments,
	];
	const customStyles = {
		headCells: {
			style: {
				justifyContent: "center",
			},
		},
		cells: {
			style: {
				justifyContent: "center",
				textAlign: "center",
			},
		},
	};

	const conditionalRowStyles = [
		{
			when: (row) => row,
			style: {
				borderWidth: "0px",
			},
		},
		{
			when: (row) => row.index % 2 === 1,
			style: {
				backgroundColor: "#f8f8f8",
				borderWidth: "0px",
			},
		},
	];

	const conditionalPaidRowStyles = [
		{
			when: (row) => row.typeDrug === "external",
			style: {
				backgroundColor: "#ddd",
			},
		},
		{
			when: (row) => row.index % 2 === 1,
			style: {
				backgroundColor: "#f8f8f8",
				borderWidth: "0px",
			},
		},
		{
			when: (row) => row.isAlreadyPaid,
			style: {
				backgroundColor: "#B6ee7a",
				borderWidth: "0px",
			},
		},
	];

	useMemo(() => {
		if (pointsExpiry) {
			setExpiryDate(
				new Date(
					new Date().setMonth(new Date().getMonth() + pointsExpiry),
				),
			);
		}
	}, [pointsExpiry]);

	useEffect(() => {
		if (fileInvoice !== null) {
			sendInvoice();
		}
	}, [fileInvoice]);

	const readFileAsync = (file) => {
		return new Promise((resolve, reject) => {
			let reader = new FileReader();

			reader.onload = () => {
				resolve(reader.result);
			};

			reader.onerror = reject;

			reader.readAsArrayBuffer(file);
		})
	}

	const getPaymentAfterSubmit = async (newPayment, haveInvoice) => {
		const { result, error } = await authorizedRequests({
			url: "payment/getPaymentByBillingId",
			method: "post",
			data: {
				_id: newPayment?.data?._id,
			},
		});

		if (result?.data) {
			if (haveInvoice) {
				setInvoicePayment(result?.data);
			}
		}
	}

	const sendInvoice = async () => {
		const formData = new FormData();
		formData.append("fullname", invoicePayment?.patient?.patientProfile?.fullName);
		formData.append("email", invoicePayment?.patient?.patientProfile?.email);
		formData.append("invoiceNo", getInvoiceId(invoicePayment?.invoiceNo));

		const readerClient = await readFileAsync(fileInvoice);
		const formFileClient = new File([readerClient], `Invoice.pdf`, { lastModified: Date.now(), type: 'application/pdf' });
		formData.append("fileInvoice", formFileClient);

		const { result, error } = await authorizedRequests({
			url: "payment/sendInvoice",
			method: "post",
			data: formData,
		});

		setFileInvoice(null);
		setInvoicePayment(null);
	}

	return (
		<>
			<div className="container">
				<div className="mainHeading px-0">
					<h1>
						<i
							className="fa fa-arrow-left cursor-pointer"
							onClick={() => {
								navigate(-1);
							}}
						></i>
						<span className="400-28-32">
							{location?.state?.formStatus} List Billing
						</span>
					</h1>
				</div>
				<div style={{ background: "white" }} className="p-3">
					<form>
						<div className="d-flex">
							<div
								className="col-md-6"
								style={{ paddingRight: "20px" }}
							>
								<Form.Group>
									<Form.Label className="black-label-text required">
										Branch
									</Form.Label>
									<SelectComponent
										singleSelect
										searchEnabled
										selectedValue={billingForm.branch}
										options={options.branches}
										onChange={(e) => {
											onFormChange("branch", e.value);
											onFormChange("location", null);
											onFormChange("patient", null);
										}}
										name={"branch"}
									/>
								</Form.Group>
								<Form.Group>
									<Form.Label className="black-label-text required">
										Location
									</Form.Label>
									<SelectComponent
										singleSelect
										searchEnabled
										// isNullEnabled
										selectedValue={billingForm.location}
										options={options.locations}
										onChange={(e) => {
											onFormChange("location", e.value);
											onFormChange("patient", null);
										}}
										name={"location"}
									/>
								</Form.Group>
								<Form.Group>
									<Form.Label className="black-label-text required">
										Field Patient
									</Form.Label>
									<SelectComponent
										singleSelect
										searchEnabled
										// isNullEnabled
										selectedValue={billingForm.patient}
										options={options.patients}
										onChange={(e) => {
											setIsMember(
												options?.patients?.find(
													(o) => o?.value == e?.value,
												)?.isMember,
											);
											setSelectedPatient(options?.patients?.find(
												(o) => o?.value == e?.value
											)?.id)
											const gstTax = options.tax.find(
												(o) =>
													o?.name?.toLowerCase() ==
													"gst",
											)?.id;
											if (gstTax) setTax([gstTax]);
											else setTax([]);

											onFormChange("patient", e.value);
											onFormChange("recommended", e.kol);

											setPromo(0);
											setUsePoint(0);
											setSubTotal(0);
											setTotal(0);
											setRewardPoints(0);
											setSessionInvoices([]);
										}}
										name={"patient"}
									/>
								</Form.Group>
								<Row className="ps-2 mt-4">
									{options?.medicationCategories?.length >
										0 &&
										options?.medicationCategories?.map(
											(med) => {
												return (
													<>
														<Button
															className="form-button m-2"
															style={{
																width: "30%",
																wordBreak:
																	"break-all",
															}}
															onClick={() => {
																setSelectedMedicationCategory(
																	med._id,
																);
																setModal(
																	"medication",
																);
																// const exists =
																// 	sessionInvoices?.find(
																// 		(
																// 			invoice,
																// 		) =>
																// 			invoice.id ==
																// 			med.id,
																// 	);
																// if (exists) {
																// 	toastify(
																// 		"Item is already in medications",
																// 		"error",
																// 	);
																// 	return;
																// }
																// let tempArr = [
																// 	...sessionInvoices,
																// ];
																// tempArr.push({
																// 	id: med.id,
																// 	name: med.name,
																// 	price: med.price,
																// 	qty: 1,
																// 	discount: 0,
																// 	total_price:
																// 		med.price,
																// 	type: "PRODUCT",
																// 	isExtra: true,
																// });
																// setSessionInvoices(
																// 	tempArr,
																// );
															}}
														>
															{med.name}
														</Button>
													</>
												);
											},
										)}

									<Button
										className="form-button m-2"
										style={{ width: "30%" }}
										onClick={() => {
											setModal("package");
										}}
									>
										+Add Package
									</Button>
									<Button
										style={{ width: "30%" }}
										className="form-button m-2"
										onClick={() => {
											setModal("treatment");
										}}
									>
										+Add Treatment
									</Button>
									<Button
										style={{ width: "30%" }}
										className="form-button m-2"
										onClick={() => {
											setModal("other");
										}}
									>
										+Add Other
									</Button>
								</Row>
							</div>

							<div
								className="col-md-6"
								style={{ paddingLeft: "20px" }}
							>
								{/* <p className="black-label-text mb-3">
									Billing Type
								</p>
								<input
									type={"checkbox"}
									checked={isFree}
									onClick={() => {
										setIsFree((val) => {
											return !val;
										});
									}}
								/>
								<span className="me-3 ms-2">Is Free</span> */}
								<p className="black-label-text mb-3 mt-3">
									Category Cost
								</p>
								<div className="d-flex flex-wrap mb-3">
									{options.categoryCost?.length > 0 &&
										options.categoryCost?.map((o) => {
											return (
												<>
													<input
														type={"checkbox"}
														checked={o.isChecked}
														onClick={() => {
															var tempArr =
																options.categoryCost;
															tempArr =
																tempArr.map(
																	(k) => {
																		if (
																			k.id ==
																			o.id
																		) {
																			return {
																				...k,
																				isChecked:
																					!k.isChecked,
																			};
																		}
																		return k;
																	},
																);
															setOptions(
																(val) => {
																	return {
																		...val,
																		categoryCost:
																			tempArr,
																	};
																},
															);
															dispatch(
																setForm({
																	parent: "billingForm",
																	child: "categoryCost",
																	value: tempArr,
																}),
															);
														}}
													/>
													<span className="me-3 ms-2">
														{o.name}
													</span>
												</>
											);
										})}
								</div>
								<Form.Group className="mt-3">
									<Form.Label className="black-label-text">
										Status *
									</Form.Label>
									<SelectComponent
										singleSelect
										searchEnabled
										options={options.status}
										selectedValue={status}
										onChange={(e) => {
											setStatus(e.value);
										}}
										placeholder="Write..."
										name={"status"}
									/>
								</Form.Group>
								<Form.Group className="">
									<Form.Label className="black-label-text">
										Recommended{" "}
										<span className="font-400-20">
											(Patient/KOL/Channel)
										</span>
									</Form.Label>
									<SelectComponent
										searchEnabled
										singleSelect
										// isNullEnabled
										// nullNotHidden
										selectedValue={billingForm.recommended}
										options={options.allPatients}
										placeholder="Write..."
										onChange={(e) => {
											onFormChange(
												"recommended",
												e.value,
											);
										}}
										name={"recommended"}
									/>
								</Form.Group>
								<Form.Group className=" mt-3">
									<Form.Label className="black-label-text">
										Campaign{" "}
									</Form.Label>
									<SelectComponent
										searchEnabled
										singleSelect
										// isNullEnabled
										// nullNotHidden
										selectedValue={billingForm.campaign}
										options={options.campaigns}
										placeholder="Write..."
										onChange={(e) => {
											onFormChange("campaign", e.value);
										}}
										name={"campaign"}
									/>
								</Form.Group>
								<Form.Group className="mt-3">
									<Form.Label className="black-label-text">
										Campaign Remarks
									</Form.Label>
									<InputGroup className="mb-3">
										<Form.Control
											name={"campaignRemarks"}
											as="textarea"
											rows={3}
											placeholder="Write..."
											style={{ resize: "none" }}
											onChange={(e) => {
												onFormChange(
													"campaignRemarks",
													e.target.value,
												);
											}}
											value={billingForm.campaignRemarks}
										/>
									</InputGroup>
								</Form.Group>
								<Form.Label className="black-label-text">
									Payment Method
								</Form.Label>
								<div>
									{options?.paymentMethods?.length > 0 &&
										options?.paymentMethods?.map((meth) => {
											return (
												<>
													<Form.Check
														inline
														label={meth.name}
														type={"radio"}
														onClick={() => {
															setPaymentMethod(
																meth._id
															);
															setPaymentMethodName(meth.name)
														}}
														checked={
															paymentMethod ===
															meth._id
														}
													/>
												</>
											);
										})}
								</div>
								{!paymentInInstallment && location?.state?.formStatus !== "Edit" && (
									<div>
										<Form.Label className="black-label-text" style={{ marginRight: "20px" }}>
											Want to pay in installments?
										</Form.Label>
										<Form.Check
											style={{ position: "relative", top: "2px" }}
											inline
											type={"checkbox"}
											value={optionalAmount}
											onClick={() => {
												setOptionalAmount(!optionalAmount)
												setStatus(false)
											}}
										/>
									</div>
								)}
							</div>
						</div>


						<div className="highlighted-container p-4 mt-2 mb-4">
							{/* <p className="font-600-24 grey mt-3">
								List Session
							</p>
							<div>
								<DataTable
									columns={session_column}
									data={session_data || []}
									customStyles={customStyles}
									conditionalRowStyles={conditionalRowStyles}
								/>
							</div>
							{billingForm.isNew &&
								billingForm.patient &&
								session_data?.length > 0 && (
									<div className="w-100">
										<Button
											className="addItem ms-auto mt-3"
											style={{
												borderRadius: "25px",
												width: "150px",
											}}
											onClick={() => {
												if (
													Object.keys(
														tempSelectedSession,
													)?.length > 0
												) {
													// setSessionInvoices([]);
													dispatch(
														setData({
															parent: "selectedSession",
															value: tempSelectedSession,
														}),
													);
												}
											}}
										>
											Populate
										</Button>
									</div>
								)} */}

							<div>
								<p className="font-600-24 grey mt-3" style={{ display: "inline-block" }}>Medications</p>

								{
									products_data?.filter(x => x.typeDrug === "external")?.length > 0 && (
										<Button
											className="form-button m-2"
											style={{ display: "inline-block", float: "right" }}
											onClick={() => {
												setModalExternal(true);
											}}
										>
											Print External Drug
										</Button>
									)
								}
							</div>
							<DataTable
								data={products_data}
								columns={products_column}
								customStyles={customStyles}
								conditionalRowStyles={conditionalPaidRowStyles}
							/>

							<p className="font-600-24 grey mt-3">Packages</p>
							<PackagesTable
								sessionInvoices={sessionInvoices}
								setPromo={setPromo}
								setSubTotal={setSubTotal}
								setTotal={setTotal}
								setTax={setTax}
								setUsePoint={setUsePoint}
								onRowEdit={(i, qty, disc, price) => {
									setItemToEdit(i);
									setNewQty(qty);
									setNewDisc(disc);
									setItemToEditPrice(price);
									setModal("edit");
								}}
								setSessionInvoices={setSessionInvoices}
							/>

							<p className="font-600-24 grey mt-4">Treatments</p>
							<DataTable
								data={treatments_data}
								columns={products_column}
								customStyles={customStyles}
								conditionalRowStyles={conditionalPaidRowStyles}
							/>
							<p className="font-600-24 grey mt-3">Others</p>
							<DataTable
								data={others_data}
								columns={others_column}
								customStyles={customStyles}
								conditionalRowStyles={conditionalPaidRowStyles}
							/>
							{/* <p className="font-600-24 grey mt-3">Paid Amount</p>
							<DataTable
									data={allPaymentRecorde?.map(obj => {
											const updatedObj = { ...obj };
											updatedObj.totalAmount = `$${obj.totalAmount}`;
											updatedObj.currentPaidAmount = `$${obj.currentPaidAmount}`
											updatedObj.remaining = `$${obj.remaining}`
											updatedObj.date = `${new Date(obj.date).getDate()}-${new Date(obj.date).getMonth()}-${new Date(obj.date).getFullYear()}`;
											return updatedObj;
									})}
									columns={payment_column}
									customStyles={customStyles}
									conditionalRowStyles={conditionalPaidRowStyles}
							/> */}
						</div>

						<Modal
							centered
							show={openModal}
							onHide={() => {
								setItemToDel(null);

								setOpenModal(!openModal);
							}}
						>
							<Modal.Body className="font-18">
								Confirm Item Deletion
								<div className="align-self-end m-3 d-flex">
									<Button
										className="me-3 delete-no ms-auto"
										onClick={() => {
											setOpenModal(false);
										}}
									>
										No
									</Button>
									<Button
										className="delete-yes"
										onClick={() => {
											if (sessionInvoices?.length == 1) {
												setSubTotal(0);
												setPromo(0);
												setTotal(0);
												// setTax([]);
												setUsePoint(0);
											}
											let tempArr = [...sessionInvoices];
											tempArr = tempArr.filter(
												(k, idx) => idx !== itemToDel,
											);
											setSessionInvoices([...tempArr]);
											setOpenModal(false);
										}}
									>
										Yes
									</Button>
								</div>
							</Modal.Body>
						</Modal>

						<div className="highlighted-container p-4">
							<p className="font-600-24 grey">Cost and Price</p>
							<div className="highlighted-container d-flex px-3 p-2 col-9 mb-2">
								<div className="font-500-20 py-1">
									<b>Available Points</b>
								</div>
								{billingForm?.patient && (
									<>
										<div className="align-self-center ms-auto font-500-20">
											{
												options?.allPatients?.find(
													(o) =>
														o.id ==
														billingForm.patient,
												)?.points
											}
										</div>
									</>
								)}
							</div>
							<div className="highlighted-container d-flex px-3 p-2 col-9">
								<div className="font-500-20 py-1">
									<b>Sub Total Amount</b>
								</div>
								<>
									<div
										className="align-self-center ms-auto font-500-20"
										style={{ fontWeight: "600" }}
									>
										${numberFormatter.format(subTotal) || 0}
									</div>
								</>
							</div>
							<div className="col-5">
								<Form.Group className="mt-3 ">
									<Form.Label className="black-label-text required">
										Discount Type
									</Form.Label>
									<SelectComponent
										singleSelect
										searchEnabled
										defaultValue={selectedOption}
										selectedValue={setSelectedOption}
										options={options.discountType}
										onChange={setSelectedOption}
									/>
								</Form.Group>
							</div>
							<Form.Group className="mt-3 ">
								<Form.Label className="black-label-text">
									Promo Discount
								</Form.Label>
								<div className="d-flex">
									<div className="col-5">
										<InputGroup>
											<Form.Control
												name={"promo"}
												type={"number"}
												className="hideArrows"
												placeholder="Write..."
												onChange={(e) => {
													if (
														e.target?.value >= 0 &&
														e.target?.value <= 100
													)
														setPromo(
															e.target.value
														);
												}}
												value={promo}
											/>
										</InputGroup>
									</div>{" "}
								</div>
							</Form.Group>
							<Form.Group className=" mt-3 col-5">
								<Form.Label className="black-label-text">
									Program Expiration
								</Form.Label>
								<SelectComponent
									searchEnabled
									isNullEnabled
									array={programExpiration}
									options={options.programs}
									placeholder="Write..."
									onChange={(e) => {
										setProgramExpiration(e);
									}}
									name={"programExpiration"}
								/>
							</Form.Group>
							<Form.Group className=" mt-3 col-5">
								<Form.Label className="black-label-text">
									Apply Tax
								</Form.Label>
								<SelectComponent
									searchEnabled
									// singleSelect
									isNullEnabled
									// nullNotHidden
									array={tax}
									options={options.tax}
									placeholder="Write..."
									onChange={(e) => {
										setTax(e);
									}}
									name={"tax"}
								/>
							</Form.Group>
							<Form.Group className="mt-3 col-5">
								<Form.Label className="black-label-text">
									Use Point
								</Form.Label>
								<InputGroup className="mb-3">
									<Form.Control
										type="number"
										className="hideArrows"
										name={"usePoint"}
										placeholder="Write..."
										onChange={(e) => {
											const curPoints =
												options?.allPatients?.find(
													(o) =>
														o.id ==
														billingForm.patient,
												);
											if (
												e.target.value <=
												curPoints?.points
												// 	&&
												// total -
												// 	e.target.value *
												// 		setting?.value >
												// 	0
											) {
												setUsePoint(e.target.value);
											}
										}}
										value={usePoint}
									/>
								</InputGroup>
							</Form.Group>
							<div className="highlighted-container d-flex px-3 p-2 col-9 mb-2">
								<span className="font-500-20 py-1">
									<b>Use Point Amount</b>
								</span>
								<span className="ms-auto font-500-20">
									${numberFormatter.format(usePoint * setting?.value) || 0}
								</span>
							</div>
							<div className="highlighted-container d-flex px-3 p-2 col-9 mb-2">
								<div className=" font-500-20 py-1">
									<b>Total Amount</b>
								</div>
								<div
									className="align-self-center ms-auto font-500-20"
									style={{ fontWeight: "600" }}
								>
									${numberFormatter.format(total) || 0}
								</div>
							</div>
							{tax.length > 0 &&
								tax.map((e) => {
									const taxDetails = options?.tax?.find(
										(o) => o.id == e,
									);

									return (
										<>
											<div className="highlighted-container d-flex px-3 p-2 col-9 mb-2">
												<div className="font-500-20 py-1">
													<b>
														Apply Tax (
														{taxDetails?.name})
													</b>
												</div>
												<div className="align-self-center ms-auto font-500-20">
													{taxDetails?.taxValue}
													{taxDetails?.type ===
														"Percentage"
														? "%"
														: ""}
												</div>
											</div>
										</>
									);
								})}
							<div className="highlighted-container d-flex px-3 p-2 col-9 mb-3">
								<div className=" font-500-20 py-1">
									<b>Total Amount GST</b>
								</div>
								<div
									className="align-self-center ms-auto font-500-20"
									style={{ fontWeight: "600" }}
								>
									${numberFormatter.format(gst) || 0}
								</div>
							</div>

							{paymentInInstallment && (
								<>
									<div className="d-flex px-3 col-9 mb-4 mt-4" style={{ border: "1px solid #ddd" }}></div>

									<div className="highlighted-container d-flex px-3 p-2 col-9 mb-2">
										<div className=" font-500-20 py-1">
											<b>Total Paid Amount</b>
										</div>
										<div
											className="align-self-center ms-auto font-500-20"
											style={{ fontWeight: "600" }}
										>
											${numberFormatter.format(paymentRecord?.payed) || 0}
										</div>
									</div>
									<div style={{ paddingLeft: "25px", paddingRight: "10px" }}>
										{
											allPaymentRecorde?.map((paidRecord, index) => (
												<div className="highlighted-container d-flex px-3 p-2 col-9 mb-2" key={index}>
													<div className=" font-500-20 py-1" style={{ fontSize: "16px" }}>
														{
															paidRecord.date ? (
																<span>
																	Paid Amount ({moment(paidRecord.date).format("DD/MMM/YYYY HH:mm:ss")})
																</span>
															) : (
																<span>Paid Amount {index + 1}</span>
															)
														}
													</div>
													<div
														className="align-self-center ms-auto font-500-20"
														style={{ fontWeight: "500", fontSize: "16px" }}
													>
														${paidRecord?.currentPaidAmount || 0}
													</div>
												</div>
											))
										}
									</div>
									<div className="highlighted-container d-flex px-3 p-2 col-9 mb-2">
										<div className=" font-500-20 py-1">
											<b>Remaining Amount</b>
										</div>
										<div
											className="align-self-center ms-auto font-500-20"
											style={{ fontWeight: "600" }}
										>
											${numberFormatter.format(paymentRecord?.remaining) || 0}
										</div>
									</div>
								</>
							)}
							{optionalAmount &&
								(
									<Form.Group className="col-5">
										<Form.Label className="black-label-text">
											Enter amount to pay
										</Form.Label>
										<InputGroup className="mb-3">
											<Form.Control
												type="number"
												className="hideArrows"
												name={"usePoint"}
												placeholder="Write..."
												onChange={(e) => {
													setInstallmentAmount(
														e.target.value
													);
												}}
												value={installmentAmount}
											/>
										</InputGroup>
									</Form.Group>
								)}
							{
								(paymentInInstallment &&
									paymentRecord && paymentRecord?.remaining !== 0) && (
									<Form.Group className="mt-3 col-5">
										<Form.Label className="black-label-text">
											Pay Remaining Amount
										</Form.Label>
										<InputGroup className="mb-3">
											<Form.Control
												type="number"
												className="hideArrows"
												name={"usePoint"}
												placeholder="Write..."
												onChange={(e) => {
													setInstallmentAmount(
														e.target.value
													);
												}}
												value={installmentAmount}
											/>
										</InputGroup>
									</Form.Group>
								)}

							<div className="col-5 mb-2 mt-2">
								<Form.Group className="" style={{ width: "100%" }}>
									<Form.Label className="black-label-text">
										Payment Remarks
									</Form.Label>
									<InputGroup className="">
										<Form.Control
											name={"remarks"}
											as="textarea"
											rows={2}
											placeholder="Write..."
											style={{ resize: "none" }}
											onChange={(e) => {
												onFormChange(
													"remarks",
													e.target.value,
												);
											}}
											value={billingForm.remarks}
										/>
									</InputGroup>
								</Form.Group>
							</div>
						</div>


						<div className="d-flex">
							<div className="col-md-5 mt-3"></div>
							<div className="col-5 ms-3"></div>
						</div>
					</form>
					<Button
						className="addItem mt-4"
						onClick={() => {
							setNeedInvoice(false);
							if (
								status &&
								isMember &&
								(location?.state?.rewardPoints == null ||
									location?.state?.rewardPoints == undefined)
							) {
								setModal("points");
							} else {
								submitForm(false);
							}
						}}
						style={{ width: "200px", height: "50px", display: "inline-block" }}
					>
						Finalize
					</Button>
					<Button
						className="addItem mt-4"
						onClick={() => {
							setNeedInvoice(true);
							if (
								status &&
								isMember &&
								(location?.state?.rewardPoints == null ||
									location?.state?.rewardPoints == undefined)
							) {
								setModal("points");
							} else {
								submitForm(true);
							}
						}}
						style={{ width: "200px", height: "50px", display: "inline-block", marginLeft: "20px" }}
					>
						Finalize & Invoicing
					</Button>
				</div>
				<Modal
					centered
					size={"xl"}
					show={showModal.medication}
					onHide={() => {
						setModal("medication");
					}}
				>
					<Modal.Header>
						<div className="d-flex justify-content-between w-100">
							<div>
								<span className="grey font-600-24 ">
									Medication and Service
								</span>
							</div>
							<i
								className="fa fa-xmark align-self-center pointer"
								onClick={() => {
									setModal("medication");
								}}
								style={{
									fontSize: "30px",
								}}
							></i>
						</div>
					</Modal.Header>
					<Modal.Body>
						<div className="d-flex w-100">
							<div className="col-6 pe-2">
								<Form.Group>
									<Form.Label className="black-label-text">
										Medication
									</Form.Label>
									<SelectComponent
										searchEnabled
										singleSelect
										// isNullEnabled
										// nullNotHidden
										selectedValue={extraStates?.product_id}
										options={
											options.medications.filter(
												(o) =>
													o.typeId ==
													selectedMedicationCategory,
											) ?? []
										}
										placeholder="Write..."
										onChange={(e) => {
											const isExists =
												sessionInvoices?.find(
													(o) => o.id == e.value,
												);
											if (isExists) {
												toastify(
													"Item already exists in invoices",
													"error",
												);
												return;
											}
											onExtraFormChange(
												"product_id",
												e.value,
											);
											if (e.value) {
												const unit_price =
													options?.medications?.find(
														(o) => o.id == e.value,
													)?.price;
												onExtraFormChange(
													"product_unit_price",
													unit_price,
												);
											}
										}}
										name={"product_id"}
									/>
								</Form.Group>
								<Form.Group>
									<Form.Label className="black-label-text">
										Quantity
									</Form.Label>
									<InputGroup className="mb-3 ">
										<Form.Control
											type="number"
											className="hideArrows"
											name={"quantity"}
											placeholder="Write..."
											onChange={(e) => {
												onExtraFormChange(
													"product_quantity",
													e.target.value,
												);
											}}
											value={extraStates.product_quantity}
										/>
									</InputGroup>
								</Form.Group>
								<Form.Group className="mt-3 ">
									<Form.Label className="black-label-text required">
										Discount Type
									</Form.Label>
									<SelectComponent
										singleSelect
										searchEnabled
										defaultValue={modalSelectedOption}
										selectedValue={modalSelectedOption}
										options={options.discountType}
										onChange={(e) => {
											onExtraFormChange(
												"product_discountType",
												e.value,
											);
											setModalSelectedOption(e);

											// if (
											// 	extraStates.product_id &&
											// 	extraStates.product_quantity &&
											// 	extraStates.product_discount <=
											// 		extraStates.product_unit_price *
											// 			extraStates.product_quantity
											// ) {
											getCalculatedPrice(
												extraStates.product_id,
												options.medications,
												extraStates.product_quantity,
												extraStates.product_discount,
												e.value,
												"product_price",
											);
											// }
										}}
									/>
								</Form.Group>
								<Form.Group>
									<Form.Label className="black-label-text">
										Discount
									</Form.Label>
									<InputGroup className="mb-3">
										<Form.Control
											type="number"
											className="hideArrows"
											name={"discount"}
											placeholder="Write..."
											onChange={(e) => {
												// if (
												// 	extraStates.product_id &&
												// 	extraStates.product_quantity &&
												// 	e.target.value <=
												// 		extraStates.product_unit_price *
												// 			extraStates.product_quantity
												// ) {
												getCalculatedPrice(
													extraStates.product_id,
													options.medications,
													extraStates.product_quantity,
													e.target.value,
													extraStates.product_discountType,
													"product_price",
												);
												onExtraFormChange(
													"product_discount",
													e.target.value,
												);
												// }
											}}
											value={extraStates.product_discount}
										/>
									</InputGroup>
								</Form.Group>
							</div>
							<div className="col-6 ps-2">
								{extraStates.product_id && (
									<>
										<div className="w-100 d-flex justify-content-between grey-div mb-2">
											<div className="font-500-20">
												Unit Price{" "}
											</div>
											<div className="font-400-20">
												<>
													{"$"}
													{
														options?.medications?.find(
															(o) =>
																o.id ==
																extraStates?.product_id,
														)?.price
													}
												</>
											</div>
										</div>
									</>
								)}
								{extraStates.product_id &&
									extraStates.product_quantity &&
									!isNaN(extraStates.product_price) && (
										<>
											<div className="w-100 d-flex justify-content-between grey-div">
												<div className="font-500-20">
													Total Price{" "}
												</div>
												<div className="font-400-20">
													{extraStates?.product_id && (
														<>
															{"$"}
															{
																extraStates.product_price
															}
														</>
													)}
												</div>
											</div>
										</>
									)}
							</div>
						</div>
						<Button
							className="addItem ms-auto mt-3"
							style={{ borderRadius: "25px", width: "150px" }}
							onClick={() => {
								if (
									!extraStates.product_id ||
									!extraStates.product_price ||
									!extraStates.product_quantity
								) {
									setModal("medication");

									return;
								}
								let tempArr = [...sessionInvoices];

								tempArr.push({
									id: extraStates.product_id,
									name: options.medications?.find(
										(o) => o.id == extraStates.product_id,
									)?.name,
									price: extraStates.product_unit_price,
									qty: extraStates.product_quantity,
									discountType: extraStates.product_discountType,
									discount: extraStates.product_discount,
									total_price: extraStates.product_price,
									type: "PRODUCT",
									isExtra: true,
								});

								setSessionInvoices(tempArr);

								setExtraStates((val) => {
									return {
										...val,
										product_discount: 0,
										product_discountType: "Amount",
										product_id: null,
										product_quantity: null,
										product_unit_price: null,
										product_price: null,
									};
								});
								setModal("medication");
								setRecalculateSub(!recalculateSub);
							}}
						>
							Save
						</Button>
					</Modal.Body>
				</Modal>
				<Modal
					centered
					size={"xl"}
					show={showModal.package}
					onHide={() => {
						onExtraFormChange("package_id", null);
						onExtraFormChange("previous_package_unique_id", null);
						onExtraFormChange("previous_package_id", null);
						onExtraFormChange("previous_billing_id", null);
						setModal("package");
					}}
				>
					<Modal.Header>
						<div className="d-flex justify-content-between w-100">
							<div>
								<span className="grey font-600-24 ">
									Package
								</span>
							</div>
							<i
								className="fa fa-xmark align-self-center pointer"
								onClick={() => {
									setModal("package");
								}}
								style={{
									fontSize: "30px",
								}}
							></i>
						</div>
					</Modal.Header>
					<Modal.Body>
						<Form.Group className="col-md-5">
							<Form.Label className="black-label-text">
								New Package
							</Form.Label>
							<SelectComponent
								searchEnabled
								singleSelect
								// isNullEnabled
								// nullNotHidden
								selectedValue={extraStates?.package_id}
								options={options.packages}
								placeholder="Write..."
								onChange={(e) => {
									const isExists = sessionInvoices.find(
										(o) => o.id == e.value,
									);
									if (isExists) {
										toastify(
											"Package already exists in invoices",
											"error",
										);
										return;
									}

									onExtraFormChange("package_id", e.value);
								}}
								name={"package_id"}
							/>
						</Form.Group>
						{billingForm.patient && (
							<>
								<Form.Group className="col-md-5">
									<Form.Label className="black-label-text">
										Previous Packages
									</Form.Label>
									<SelectComponent
										searchEnabled
										singleSelect
										selectedValue={
											extraStates?.previous_package_unique_id
										}
										options={options.previousPackages}
										placeholder="Write..."
										onChange={(e) => {
											const isExists =
												sessionInvoices.find(
													(o) => o.id == e.value,
												);
											const remainingProducts =
												e?.products?.find(
													(o) => o.used < o.qty,
												);
											const remainingTreatments =
												e?.treatments?.find(
													(o) => o.used < o.limit,
												);
											// if (
											// 	!remainingProducts?.id &&
											// 	!remainingTreatments?.id &&
											// 	e.value
											// ) {
											// 	toastify(
											// 		"This package has already been completely used",
											// 		"error",
											// 	);
											// 	return;
											// }
											if (isExists) {
												toastify(
													"Package already exists in invoices",
													"error",
												);
												return;
											}

											onExtraFormChange(
												"previous_package_unique_id",
												e.value,
											);
											onExtraFormChange(
												"previous_package_id",
												e.packageId,
											);
											onExtraFormChange(
												"previous_billing_id",
												e.billingId,
											);
										}}
										name={"package_id"}
									/>
								</Form.Group>
							</>
						)}
						{/* {extraStates.package_id && (
							<>
								<DataTable
									columns={package_column}
									data={package_data || []}
									pagination
									customStyles={customStyles}
									conditionalRowStyles={
										conditionalPaidRowStyles
									}
								/>
							</>
						)} */}
						<Button
							className="addItem ms-auto mt-3"
							style={{ borderRadius: "25px", width: "150px" }}
							onClick={() => {
								const tempArr = [...sessionInvoices];
								if (extraStates.package_id) {
									const packageDetails =
										options.packages.find(
											(o) =>
												o.id == extraStates.package_id
										);
									tempArr.push({
										id: extraStates.package_id,
										qty: packageDetails.qty || 1,
										price: packageDetails.price,
										discount: packageDetails.discount || 0,
										expiredDate:
											packageDetails?.expiredDate,
										name: packageDetails.name,
										treatments: packageDetails.treatments,
										products: packageDetails.products,
										total_price: packageDetails.price,
										type: "PACKAGE",
										isExtra: true,
									});
								}

								if (extraStates.previous_package_id) {
									const previousPackageDetails =
										options.previousPackages.find(
											(o) =>
												o.value ==
												extraStates?.previous_package_unique_id
										);
									tempArr.push({
										id: extraStates.previous_package_unique_id,
										// uniqueId:extraStates.previous_package_unique_id,
										qty: previousPackageDetails.qty || 1,
										price: previousPackageDetails.price,
										discount:
											previousPackageDetails.discount ||
											0,
										name: previousPackageDetails.label,
										treatments:
											previousPackageDetails.treatments,
										products:
											previousPackageDetails.products,
										total_price:
											previousPackageDetails.price,
										type: "PACKAGE",
										billingId:
											previousPackageDetails.billingId,
										isAlreadyPaid: true,
										isExtra: true,
									});
								}

								setSessionInvoices(tempArr);
								setRecalculateSub(!recalculateSub);

								setExtraStates((val) => {
									return {
										...val,
										package_id: null,
										previous_package_id: null,
										previous_billing_id: null,
										previous_package_unique_id: null,
									};
								});
								setModal("package");
							}}
						>
							Save
						</Button>
					</Modal.Body>
				</Modal>
				<Modal
					centered
					show={showModal?.points}
					onHide={() => {
						setModal("points");
					}}
				>
					<Modal.Body>
						<div className="text-center w-100 px-5 py-3">
							<span className="font-600-24 theme">
								This billing will get a reward point
							</span>
						</div>
						<div className="w-100 px-5 ">
							<Form.Group className="w-100">
								<Form.Label className="black-label-text">
									Points
								</Form.Label>
								<InputGroup>
									<Form.Control
										type="number"
										className="hideArrows"
										name={"rewardPoints"}
										placeholder="Write..."
										onChange={(e) => {
											setRewardPoints(e.target.value);
										}}
										value={rewardPoints}
									/>
								</InputGroup>
							</Form.Group>
							<div className="d-flex mt-2 justify-content-between">
								{expiryDate && (
									<>
										<Form.Group className="w-100">
											<Form.Label className="black-label-text">
												Expiry Date
											</Form.Label>
											<DateInput
												value={expiryDate}
												placeholder="Start Date"
												onChange={(e) => {
													setExpiryDate(e);
												}}
											/>
										</Form.Group>
									</>
								)}

								{/* 
								<span>
									{new Date(
										new Date().setMonth(
											new Date().getMonth() +
												pointsExpiry,
										),
									).toLocaleDateString()}
								</span> */}
							</div>
						</div>
						<div className="d-flex mt-4">
							<Button
								className="white-button"
								style={{ width: "200px", height: "45px" }}
								onClick={() => {
									setModal("points");
								}}
							>
								Cancel
							</Button>
							<Button
								className="addItem ms-auto"
								style={{ width: "200px", height: "45px" }}
								onClick={() => {
									setModal("points");
									submitForm(needInvoice);
								}}
							>
								Save
							</Button>
						</div>
					</Modal.Body>
				</Modal>
				<Modal
					centered
					size={"xl"}
					show={showModal.treatment}
					onHide={() => {
						setExtraStates((val) => {
							return {
								...val,
								service_discount: 0,
								service_discountType: "Amount",
								service_id: null,
								service_quantity: null,
								service_unit_price: null,
								service_price: null,
							};
						});
						setModal("treatment");
					}}
				>
					<Modal.Header>
						<div className="d-flex justify-content-between w-100">
							<div>
								<span className="grey font-600-24 ">
									Treatments
								</span>
							</div>
							<i
								className="fa fa-xmark align-self-center pointer"
								onClick={() => {
									setModal("treatment");
								}}
								style={{
									fontSize: "30px",
								}}
							></i>
						</div>
					</Modal.Header>
					<Modal.Body>
						<div className="d-flex w-100">
							<div className="col-6 pe-2">
								<Form.Group>
									<Form.Label className="black-label-text">
										Treatment
									</Form.Label>
									<SelectComponent
										searchEnabled
										singleSelect
										// isNullEnabled
										// nullNotHidden
										selectedValue={extraStates?.service_id}
										options={options.treatments}
										placeholder="Write..."
										onChange={(e) => {
											const isExists =
												sessionInvoices.find(
													(o) => o.id == e.value
												);
											if (isExists) {
												toastify(
													"Treatment already exists in invoices",
													"error"
												);
												return;
											}
											onExtraFormChange(
												"service_id",
												e.value
											);
											if (e.value) {
												const unit_price =
													options?.treatments?.find(
														(o) => o.id == e.value
													)?.price;

												onExtraFormChange(
													"service_unit_price",
													unit_price
												);
											}
										}}
										name={"service_id"}
									/>
								</Form.Group>
								<Form.Group>
									<Form.Label className="black-label-text">
										Quantity
									</Form.Label>
									<InputGroup className="mb-3 ">
										<Form.Control
											type="number"
											className="hideArrows"
											name={"quantity"}
											placeholder="Write..."
											onChange={(e) => {
												onExtraFormChange(
													"service_quantity",
													e.target.value
												);
											}}
											value={extraStates.service_quantity}
										/>
									</InputGroup>
								</Form.Group>
								<div className="">
									<Form.Group className="mt-3 ">
										<Form.Label className="black-label-text required">
											Discount Type
										</Form.Label>
										<SelectComponent
											singleSelect
											searchEnabled
											defaultValue={modalSelectedOption}
											selectedValue={modalSelectedOption}
											options={options.discountType}
											onChange={(e) => {
												onExtraFormChange(
													"service_discountType",
													e.value
												);
												setModalSelectedOption(e);

												// 	if (
												// 		extraStates.service_id &&
												// 		extraStates.service_quantity &&
												// 		extraStates.service_discount <=
												// 		extraStates.service_unit_price *
												// 		extraStates.service_quantity
												// ) {
												getCalculatedPrice(
													extraStates.service_id,
													options.treatments,
													extraStates.service_quantity,
													extraStates.service_discount,
													e.value,
													"service_price"
												);
												// }
											}}
										/>
									</Form.Group>
								</div>
								<Form.Group>
									<Form.Label className="black-label-text">
										Discount
									</Form.Label>
									<InputGroup className="mb-3">
										<Form.Control
											type="number"
											className="hideArrows"
											name={"discount"}
											placeholder="Write..."
											onChange={(e) => {
												// if (
												//     extraStates.service_id &&
												//     extraStates.service_quantity &&
												//     e.target.value <=
												//     extraStates.service_unit_price *
												//     extraStates.service_quantity
												// ) {

												getCalculatedPrice(
													extraStates.service_id,
													options.treatments,
													extraStates.service_quantity,
													e.target.value,
													extraStates.service_discountType,
													"service_price"
												);
												onExtraFormChange(
													"service_discount",
													e.target.value
												);
												// }
											}}
											value={extraStates.service_discount}
										/>
									</InputGroup>

								</Form.Group>
							</div>
							<div className="col-6 ps-2">
								{extraStates.service_id && (
									<>
										<div className="w-100 d-flex justify-content-between grey-div mb-2">
											<div className="font-500-20">
												Unit Price{" "}
											</div>
											<div className="font-400-20">
												<>
													{"$"}
													{
														options?.treatments?.find(
															(o) =>
																o.id ==
																extraStates?.service_id
														)?.price
													}
												</>
											</div>
										</div>
									</>
								)}
								{extraStates.service_id &&
									extraStates.service_quantity &&
									!isNaN(extraStates.service_price) && (
										<>
											<div className="w-100 d-flex justify-content-between grey-div">
												<div className="font-500-20">
													Total Price{" "}
												</div>
												<div className="font-400-20">
													{extraStates?.service_id && (
														<>
															{"$"}
															{
																extraStates.service_price
															}
														</>
													)}
												</div>
											</div>
										</>
									)}
							</div>
						</div>
						<Button
							className="addItem ms-auto mt-3"
							style={{ borderRadius: "25px", width: "150px" }}
							onClick={() => {
								if (
									!extraStates.service_id ||
									!extraStates.service_price ||
									!extraStates.service_quantity
								) {
									setModal("treatment");

									return;
								}
								const tempArr = [...sessionInvoices];
								tempArr.push({
									id: extraStates.service_id,
									name: options.treatments?.find(
										(o) => o.id == extraStates.service_id
									)?.name,
									price: extraStates.service_unit_price,
									qty: extraStates.service_quantity,
									discount: extraStates.service_discount,
									discountType: extraStates.service_discountType,
									total_price: extraStates.service_price,
									type: "SERVICE",
									isExtra: true,
								});
								setSessionInvoices([...tempArr]);
								setRecalculateSub(!recalculateSub);

								setExtraStates((val) => {
									return {
										...val,
										service_discount: 0,
										service_discountType: "Amount",
										service_id: null,
										service_quantity: null,
										service_unit_price: null,
										service_price: null,
									};
								});
								setModal("treatment");
							}}
						>
							Save
						</Button>
					</Modal.Body>
				</Modal>
				<Modal
					centered
					show={showModal.edit}
					onHide={() => {
						setModal("edit");
					}}
				>
					<Modal.Header>
						<div className="d-flex justify-content-between w-100">
							<div>
								<span className="grey font-600-24 ">Edit</span>
							</div>
							<i
								className="fa fa-xmark align-self-center pointer"
								onClick={() => {
									setModal("edit");
								}}
								style={{
									fontSize: "30px",
								}}
							></i>
						</div>
					</Modal.Header>
					<Modal.Body>
						<Form.Group className="mt-3">
							<Form.Label className="black-label-text">
								Quantity
							</Form.Label>
							<InputGroup className="mb-3">
								<Form.Control
									name={"quantity"}
									className="hideArrows"
									placeholder="Write..."
									onChange={(e) => {
										setNewQty(e.target.value);
									}}
									value={newQty}
								/>
							</InputGroup>
						</Form.Group>
						<Form.Group className="mt-3">
							<Form.Label className="black-label-text">
								Discount Type
							</Form.Label>
							<SelectComponent
								singleSelect
								searchEnabled
								defaultValue={newDiscType}
								selectedValue={newDiscType}
								options={options.discountType}
								onChange={(e) => {
									setNewDiscType(e.value);
								}}
							/>
						</Form.Group>
						<Form.Group className="mt-3">
							<Form.Label className="black-label-text">
								Discount
							</Form.Label>
							<InputGroup className="mb-3">
								<Form.Control
									name={"discount"}
									className="hideArrows"
									placeholder="Write..."
									onChange={(e) => {
										setNewDisc(e.target.value);
									}}
									value={newDisc}
								/>
							</InputGroup>
						</Form.Group>
						<Button
							className="addItem ms-auto"
							onClick={() => {
								let tempArr = [...sessionInvoices];
								tempArr = tempArr.map((o, i) => {
									if (i == itemToEdit) {
										return {
											...o,
											qty: newQty,
											discount: newDisc,
											discountType: newDiscType,
											total_price: returnCalculatedPrice(),
										};
									}
									return o;
								});
								setSessionInvoices(tempArr);
								setRecalculateSub(!recalculateSub);
								setModal("edit");
							}}
						>
							Save
						</Button>
					</Modal.Body>
				</Modal>
				<Modal
					centered
					show={showModal.other}
					onHide={() => {
						setItemToEdit();
						onExtraFormChange("others_description", "");
						onExtraFormChange("others_price", 0);
						setModal("other");
					}}
				>
					<Modal.Header>
						<div className="d-flex justify-content-between w-100">
							<div>
								<span className="grey font-600-24 ">Other</span>
							</div>
							<i
								className="fa fa-xmark align-self-center pointer"
								onClick={() => {
									setModal("other");
								}}
								style={{
									fontSize: "30px",
								}}
							></i>
						</div>
					</Modal.Header>
					<Modal.Body>
						<Form.Group className="mt-3">
							<Form.Label className="black-label-text">
								Description
							</Form.Label>
							<InputGroup className="mb-3">
								<Form.Control
									placeholder="Write..."
									onChange={(e) => {
										setExtraStates({
											...extraStates,
											others_description: e.target.value,
										});
									}}
									value={extraStates.others_description}
								/>
							</InputGroup>
						</Form.Group>
						<Form.Group className="mt-3">
							<Form.Label className="black-label-text">
								Price
							</Form.Label>
							<InputGroup className="mb-3">
								<Form.Control
									// name={"remarks"}
									type="number"
									className="hideArrows"
									placeholder="Write..."
									onChange={(e) => {
										setExtraStates({
											...extraStates,
											others_price: e.target.value,
										});
									}}
									value={extraStates?.others_price}
								/>
							</InputGroup>
						</Form.Group>
						<Button
							className="addItem ms-auto"
							onClick={() => {
								if (!extraStates.others_description) {
									toastify("Description is missing", "error");
									return;
								}
								if (isNaN(extraStates.others_price)) {
									toastify("Price is missing", "error");
									return;
								}
								if (!isNaN(itemToEdit)) {
									let tempArr = sessionInvoices.map(
										(o, i) => {
											if (i == itemToEdit) {
												return {
													...o,
													description:
														extraStates.others_description,
													total_price:
														extraStates.others_price,
												};
											} else {
												return o;
											}
										}
									);
									setSessionInvoices(tempArr);
								} else {
									let tempArr = [
										...sessionInvoices,
										{
											description:
												extraStates.others_description,
											total_price:
												extraStates.others_price,
											type: "OTHER",
											isExtra: true,
										},
									];
									setSessionInvoices(tempArr);
								}

								setRecalculateSub(!recalculateSub);
								onExtraFormChange("others_description", "");
								onExtraFormChange("others_price", 0);
								setItemToEdit();
								setModal("other");
							}}
						>
							Save
						</Button>
					</Modal.Body>
				</Modal>

				{
					invoicePayment && (
						<BlobProvider document={<InvoicePDF billing={invoicePayment} setting={companySetting} />}>
							{({ blob }) => {
								if (blob !== null) {
									setFileInvoice(blob);
								}
								return "";
							}}
						</BlobProvider>
					)
				}

				{
					modalExternal && (
						<Modal
							centered
							show={modalExternal}
							onHide={() => {
								setModalExternal(false);
							}}
							size="xl"
						>
							<Modal.Header closeButton>
								<Modal.Title id="contained-modal-title-vcenter">
									External Drug
								</Modal.Title>
							</Modal.Header>

							<div className="pdf-btn">
								<PDFViewer style={{ width: "100%", height: "500px" }}>
									<ExternalPDF products={products_data} templates={externalTemplates} />
								</PDFViewer>
							</div>
						</Modal>
					)
				}
			</div>
		</>
	);
}
